import React from 'react';
import DriveGallery from '../../components/DriveGallery';

const DetskyDen = () => (
  <DriveGallery
    galleryId="detsky-den"
    title="Dětský den"
  />
);

export default DetskyDen;
